import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('a-card', {
    staticClass: "app-box",
    attrs: {
      "bordered": false
    }
  }, [_c('tip'), !_vm.isFinished ? _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loading
    }
  }, [_c('div', {
    staticClass: "survey"
  }, [_c('div', {
    staticClass: "survey-title"
  }, [_vm._v(_vm._s(_vm.surveyDetails.title))]), _c('pre', {
    staticClass: "mt-20 mb-20 survey-welcome"
  }, [_vm._v(_vm._s(_vm.surveyDetails.welcome_text))]), _vm.showQuestionList.length ? _c('div', {
    staticClass: "survey-content mt-20"
  }, [_vm._l(_vm.showQuestionList, function (item, index) {
    return [_vm.showQuestionByDependent(item.question_id) ? _c('div', {
      key: item.question_id,
      staticClass: "question"
    }, [_c('span', {
      staticClass: "question-require"
    }, [item.mandatory ? _c('span', [_vm._v("*")]) : _vm._e()]), _c('div', {
      staticClass: "question-content"
    }, [_c('div', {
      staticClass: "question-title"
    }, [_c('span', [_vm._v(_vm._s(index + 1) + "." + _vm._s(item.title))]), item.tips ? _c('span', {
      staticClass: "question-tips"
    }, [_c('a-icon', {
      staticClass: "ml-5",
      attrs: {
        "type": "exclamation-circle"
      }
    }), _vm._v(" " + _vm._s(item.tips) + " ")], 1) : _vm._e(), item.no_contact ? _c('a-button', {
      staticClass: "question-contact",
      attrs: {
        "type": "link",
        "disabled": Boolean(item.is_no_contact),
        "fbu-analyse-name": $t("\u672A\u63A5\u89E6\uFF0C\u4E0D\u4E86\u89E3")
      },
      on: {
        "click": function ($event) {
          return _vm.handleClickNoContact(item);
        }
      }
    }, [_vm._v(_vm._s(_vm.t('未接触，不了解')))]) : _vm._e()], 1), _c('div', {
      staticClass: "question-form"
    }, [_c('survey-' + item.type, {
      tag: "component",
      attrs: {
        "options": item.options,
        "children": item.children
      },
      on: {
        "input": function ($event) {
          return _vm.handleInput(item);
        }
      },
      model: {
        value: item.answer,
        callback: function ($$v) {
          _vm.$set(item, "answer", $$v);
        },
        expression: "item.answer"
      }
    })], 1), item.type === _vm.$enum.survey.QuestionTypeEnum.PIVOTAL_INPUT && !item.match && item.errorMsg ? _c('div', {
      staticClass: "question-message ml-10"
    }, [_vm._v(" " + _vm._s(item.errorMsg) + " ")]) : !item.match ? _c('div', {
      staticClass: "question-message ml-10"
    }, [_vm._v(" " + _vm._s(_vm.t('请完整回答此题')) + " ")]) : _vm._e()])]) : _vm._e()];
  }), _c('div', {
    staticClass: "question"
  }, [_c('div', {
    staticClass: "question-content"
  }, [_c('div', {
    staticClass: "question-form"
  }, [_c('my-input', {
    attrs: {
      "fbu-analyse-name": $t("\u8BF7\u8F93\u5165\u60A8\u7684\u5B9D\u8D35\u610F\u89C1"),
      "placeholder": _vm.t('请输入您的宝贵意见'),
      "rows": 4,
      "maxLength": 100,
      "type": "textarea"
    },
    model: {
      value: _vm.advise,
      callback: function ($$v) {
        _vm.advise = $$v;
      },
      expression: "advise"
    }
  })], 1), _vm.adviseIsRequire && !_vm.advise && _vm.showAdvisErrorMessage ? _c('div', {
    staticClass: "question-message ml-10"
  }, [_vm._v(" " + _vm._s(_vm.t('请输入您的宝贵意见')) + " ")]) : _vm._e()])])], 2) : _vm._e()]), _vm.isSuccessLoad && !_vm.isPreview ? _c('footer-tool', [_c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "type": "primary",
      "data-permission": "survey_submit",
      "id": "survey_submit",
      "disabled": !_vm.isSuccessLoad || _vm.submitLoading,
      "fbu-analyse-name": $t("\u63D0\u4EA4")
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.t('提交')))])], 1) : _vm._e()], 1) : _vm._e(), _vm.isFinished ? _c('div', {
    staticClass: "mt-60 survey-close"
  }, [_c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "type": "primary",
      "data-permission": "survey_close",
      "id": "survey_close",
      "fbu-analyse-name": $t("\u5173\u95ED\u9875\u9762")
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(_vm._s(_vm.t('关闭页面')))])], 1) : _vm._e()], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };